import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';




export const StoreCleaner = () => {

    // const { setUserList, setUserSelectedList } = useCalendarStore();


    const location = useLocation();



    useEffect(() => {
        console.log('+++++++++++');
        console.log('+++++ StoreCleaner', location.pathname);
        console.log('Agrega tu store para limpiarlo en la ruta actual');
        console.log('+++++++++++');

        switch (location.pathname) {

            case '/dashboard/calendario':
                // setUserList([]);
                // setUserSelectedList([]);
                console.warn('StoreCleaner: Se ha limpiado el store de usuarios');
                break;
            default:
                break;




        };
    }, [location.pathname]);

    return null; // This component doesn't render anything
};

